import { Component, OnInit } from '@angular/core';
import { NewsletterApi, Category, Subscriber, UpdateSubscriber } from '../newsletter-api.service';
import { StateService } from '../state.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceService } from '../resources.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  groups: any[];
  subscriber: Subscriber;
  newSubscriber: boolean = false;
  saved: boolean = false;

  constructor(
    private api : NewsletterApi,
    private stateService : StateService,
    private router : Router,
    private route: ActivatedRoute,
    private r: ResourceService
    ) { }

  ngOnInit() {
    if(!this.stateService.email && !this.route.snapshot.queryParams["hash"])
      this.router.navigate(['/']);
    
    this.api.getCategories().subscribe(c => {
      var groups = [];
      // Group by group name
      c.forEach((cat, i) => {
        var existingGroup = groups.filter(g => g.GroupName == cat.GroupName);
        if(existingGroup.length > 0)
          existingGroup[0].Categories.push(cat);
        else
          groups.push({ GroupName: cat.GroupName, Categories: [ cat ], SortOrder: cat.SortOrder })
      });
      groups.sort((a,b) => a.SortOrder < b.SortOrder ? -1 : 0);
      groups.forEach(g => g.Categories = g.Categories.sort((a,b) => a.CategoryLanguage < b.CategoryLanguage ? -1 : 0));
      this.groups = groups;
    });

    if(this.stateService.email) {
      this.subscriber = new Subscriber(this.stateService.email, []);
      this.newSubscriber = true;
    }
    else if(this.route.snapshot.queryParams["hash"]) {
      var tempSubscriber = new UpdateSubscriber(this.stateService.email, []);
      tempSubscriber.hash = this.route.snapshot.queryParams["hash"];
      tempSubscriber.validUntil = this.route.snapshot.queryParams["vt"];
      tempSubscriber.id = parseInt(this.route.snapshot.queryParams["id"])
      this.api.getSubscriber(tempSubscriber).subscribe(s => { this.subscriber = s; console.log(s); });
    }
    
  }

  save() {
    if(this.newSubscriber){
      this.api.newSubscriber(this.subscriber).subscribe(result => this.saved = true);
    }
    else {
      var updateSubscriber = this.subscriber as UpdateSubscriber;
      this.api.updateSubscriber(updateSubscriber).subscribe(res => this.saved = true);
    }
  }

  unsubscribe() {
    if(confirm("Sind Sie sicher?")) {
      this.subscriber.categories = [];
      this.save();
    }
  }

  allSelected(lang) {
    if(!this.groups || !this.subscriber) return false;
    const unselected = this.groups.filter(g => g.Categories.filter(c => c.CategoryLanguage === lang).some(c => !this.subscriber.hasCategory(c.Id)))
    return unselected.length === 0;
  }

  toggleAll(lang) {
    const state = !this.allSelected(lang)
    this.groups.forEach(g =>
      g.Categories
        .filter(c => c.CategoryLanguage === lang)
        .forEach(c => this.subscriber.setCategory(c.Id, state))
    )
  }

}


